import { EditableCard } from "../../../components/editableCard.component";
import { ApiSchemaCompany } from "../../../models/api";
import { TableCardPlaceholder } from "../../../components/placeholders.component";
import { AppRouteUi } from "../../../config/appRoute";
import { useParams } from "react-router";

type Props = {
  data: ApiSchemaCompany | undefined;
  isValidating: boolean;
};

export const ImportantInfoCard = (props: Props) => {
  const { companyId } = useParams<{ companyId: string }>();
  return (
    <EditableCard
      link={`${AppRouteUi.Company.Root()}/update/${companyId}`}
      title="Important info"
      isValidating={props.isValidating}
      className="h-100"
    >
      {props.isValidating ? (
        <TableCardPlaceholder rows={7} />
      ) : (
        <table className="w-100 ">
          {!!props.data?.email && (
            <tr>
              <td className="p-3 border-bottom pe-2">Email Address</td>
              <td className="p-3 border-bottom ps-2">{props.data?.email}</td>
            </tr>
          )}
          {!!props.data?.phone && (
            <tr>
              <td className="p-3 border-bottom pe-2">Phone Number</td>
              <td className="p-3 border-bottom ps-2">{props.data?.phone}</td>
            </tr>
          )}
          {!!props.data?.address && (
            <tr>
              <td className="p-3 border-bottom pe-2">Address</td>
              <td className="p-3 border-bottom ps-2">{props.data?.address}</td>
            </tr>
          )}
          {!!props.data?.representativeName && (
            <tr>
              <td className="p-3 border-bottom pe-2">Company representative</td>
              <td className="p-3 border-bottom ps-2">
                {props.data?.representativeName}
              </td>
            </tr>
          )}
          {!!props.data?.representativePhone && (
            <tr>
              <td className="p-3 border-bottom pe-2">
                Company representative Number
              </td>
              <td className="p-3 border-bottom ps-2">
                {props.data?.representativePhone}
              </td>
            </tr>
          )}
          {!!props.data?.providerNumber && (
            <tr>
              <td className="p-3 border-bottom pe-2">NPI/Provider Number</td>
              <td className="p-3 border-bottom ps-2">
                {props.data?.providerNumber}
              </td>
            </tr>
          )}
          {!!props.data?.rate && (
            <tr>
              <td className="p-3 border-bottom pe-2">Company Rate</td>
              <td className="p-3 border-bottom ps-2">{props.data?.rate}</td>
            </tr>
          )}
          {/* <tr>
            <td className="p-3 border-bottom pe-2">Rate</td>
            <td className="p-3 border-bottom ps-2">
              ${props.data?.rate} per/unit
            </td>
          </tr> */}
        </table>
      )}
    </EditableCard>
  );
};
